import { Box } from "@mui/material";
import { toast } from "react-toastify";
import {
  useDeleteHuddleCallMutation,
  useGetHuddleCallsQuery,
} from "../../../../services/admin";
import { ClientAntTab, ClientAntTabs } from "../../../../styles/ResourcesLibraryStyle";
import { useDispatch, useSelector } from "react-redux";
import { setRecentCallsResourceTabIndex } from "../../../../store/slices/admin.slice";
import { selectRecentCallsResourceTabIndex } from "../../../../store/selectors";
import { ClientTabPanel } from "../Index";
import CallRecordings from "./tabs/CallRecordings";
import GroupCallRecordings from "./tabs/GroupCallRecordings";
import CallUploads from "./tabs/CallUploads";

const RecentHuddleCall = () => {
  const value = useSelector(selectRecentCallsResourceTabIndex);
  const dispatch = useDispatch();

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    dispatch(setRecentCallsResourceTabIndex(newValue))
  };

  const { data, isLoading, refetch } = useGetHuddleCallsQuery({ type: "call" }, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true
  });
  const [deleteHuddleCall] = useDeleteHuddleCallMutation();

  const deleteHandler = (id: string, type: string) => {
    const payload = {
      id: id,
      callType: "call",
      recordType: type
    };

    deleteHuddleCall(payload).unwrap().then(() => {
      refetch();
      toast.success("Deleted Successfully");
    }).catch(() => {
      toast.error("Something went wrong ")
    });
  };

  const calls = data?.data?.data;
  const zoomCalls = calls?.zoom || [];
  const groupZoomCalls = calls?.groupZoom || [];
  const uploadCalls = calls?.upload || [];

  const sortedZoomCalls = [...zoomCalls]?.sort((a: any, b: any) => {
    const aDate = new Date(a?.start_time)?.getTime();
    const bDate = new Date(b?.start_time)?.getTime();
    return bDate - aDate
  })

  const sortedGroupZoomCalls = [...groupZoomCalls]?.sort((a: any, b: any) => {
    const aDate = new Date(a?.start_time)?.getTime();
    const bDate = new Date(b?.start_time)?.getTime();
    return bDate - aDate
  })

  const sortedUploads = [...uploadCalls]?.sort((a: any, b: any) => {
    const aDate = new Date(a?.createdAt)?.getTime();
    const bDate = new Date(b?.createdAt)?.getTime();
    return bDate - aDate
  })

  return (
    <Box>
      <Box sx={{ maxWidth: "100%" }}>
        <ClientAntTabs
          value={value}
          onChange={handleChange}
          aria-label="ant example"
        >
          <ClientAntTab label="Call Recordings" />
          <ClientAntTab label="Group Call Recordings" />
          <ClientAntTab label="Call Uploads" />
        </ClientAntTabs>
      </Box>

      <ClientTabPanel value={value} index={0}>
        <CallRecordings
          zoomCalls={sortedZoomCalls}
          isLoading={isLoading}
          deleteHandler={deleteHandler}
        />
      </ClientTabPanel>

      <ClientTabPanel value={value} index={1}>
        <GroupCallRecordings
          groupZoomCalls={sortedGroupZoomCalls}
          isLoading={isLoading}
          deleteHandler={deleteHandler}
        />
      </ClientTabPanel>

      <ClientTabPanel value={value} index={2}>
        <CallUploads
          uploadedCalls={sortedUploads}
          isLoading={isLoading}
          deleteHandler={deleteHandler}
        />
      </ClientTabPanel>
    </Box>
  );
};

export default RecentHuddleCall;
